import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app-shell/billing/$projectId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      params,
      to: "/billing/$projectId/overview",
    });
  },
  component: () => null,
});
